import React from 'react';

// ============================================================
// Footer + Hero banner + global chrome pieces
// ============================================================

export function Footer({ onNavigate }) {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand">
          <div className="footer-brand-row">
            <img src="/assets/logo-color.svg" alt="New Economy Index" className="logo-img"/>
          </div>
          <p className="footer-tagline">
            Making Europe's new economy ecosystem visible.
          </p>
        </div>
        <div>
          <div className="footer-col-title">Main pages</div>
          <div className="footer-links">
            <a href="#/" onClick={(e) => { e.preventDefault(); onNavigate('directory'); }}>Home</a>
            <a href="#/about" onClick={(e) => { e.preventDefault(); onNavigate('about'); }}>About</a>
            <a href="#/typology" onClick={(e) => { e.preventDefault(); onNavigate('typology'); }}>Categorisation</a>
            <a href="#/submit" onClick={(e) => { e.preventDefault(); onNavigate('submit'); }}>Add / Update</a>
          </div>
        </div>
        <div>
          <div className="footer-col-title">Supported by</div>
          <div className="footer-links">
            <a href="https://www.metabolic.nl" target="_blank" rel="noopener noreferrer">Metabolic</a>
            <a href="https://p4ne.org/" target="_blank" rel="noopener noreferrer">Partners for a New Economy</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div>Copyleft © {new Date().getFullYear()} · CC-BY-NC</div>
        <div className="footer-bottom-links">
          <a href="mailto:NEindexEU@metabolic.nl">Contact</a>
        </div>
      </div>
    </footer>
  );
}

export function DirectoryHero({ count, onNavigate }) {
  return (
    <section className="directory-hero">
      <div className="directory-hero-inner">
        <div className="directory-hero-text">
          <div className="directory-hero-eyebrow">
            <span className="directory-hero-dot" aria-hidden="true"/>
            The Directory
          </div>
          <h1 className="directory-hero-title" style={{fontSize: '20px', color: 'rgb(103, 96, 77)'}}>
            Explore organizations across Europe working on transforming economic systems.
          </h1>
        </div>
        <div className="directory-hero-meta">
          <a href="#/about" className="directory-hero-link"
             onClick={(e) => { if (onNavigate) { e.preventDefault(); onNavigate('about'); } }}>
            What this is →
          </a>
          <span className="directory-hero-divider" aria-hidden="true"/>
          <a href="#/submit" className="directory-hero-link"
             onClick={(e) => { if (onNavigate) { e.preventDefault(); onNavigate('submit'); } }}>
            Add your org →
          </a>
        </div>
      </div>
    </section>
  );
}

export function DirectorySearchBar({ search, setSearch }) {
  return (
    <div className="directory-searchbar">
      <div className="directory-searchbar-inner">
        <div className="hero-search">
          <svg viewBox="0 0 16 16" width="14" height="14" className="search-icon">
            <circle cx="7" cy="7" r="5" fill="none" stroke="currentColor" strokeWidth="1.4"/>
            <path d="M11 11l4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
          </svg>
          <input
            type="text"
            placeholder="Search organisations, themes, countries…"
            value={search || ''}
            onChange={e => setSearch && setSearch(e.target.value)}
          />
          {search && <button className="clear-search" onClick={() => setSearch('')}>✕</button>}
        </div>
        <p className="directory-searchbar-note">
          <span>Organisations self-select their tags.</span>
          <span>Some don't have complete profiles yet, but still appear when you search by geography or name.</span>
        </p>
      </div>
    </div>
  );
}
